import { toast } from "../../components/ui/use-toast";
import axios from "axios";
import { CircleCheckBig } from "lucide-react";
import { z } from "zod";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllApplications = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseUrl}/api/applications`, config);
    return { applications: response.data.applications };
  } catch (error) {
    console.error(error);
  }
};

export const postApplication = async (formData: any) => {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const newsFormData = new FormData();

    for (const key in formData) {
      if (
        formData.hasOwnProperty(key) &&
        key !== "coverLetter" &&
        key !== "resume"
      ) {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            newsFormData.append(key, JSON.stringify(formData[key]));
          } else {
            newsFormData.append(key, formData[key]);
          }
        }
      }
    }
    // Check and append cover letter and resume files
    if (formData.coverLetter && formData.coverLetter.file) {
      newsFormData.append("coverLetter", formData.coverLetter.file);
    }
    if (formData.resume && formData.resume.file) {
      newsFormData.append("resume", formData.resume.file);
    }

    const response = await axios.post(
      `${baseUrl}/api/applications`,
      newsFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });

    return true;
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteApplication = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(
      `${baseUrl}/api/applications/${id}`,
      config
    );
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};
